import React from 'react';
import { bool, func } from 'prop-types';

// Components
import { Box, Button } from '@mui/material';
import * as styles from '../ConfirmSubscriptionCard.styles';

const footerButtonStyles = {
  marginLeft: theme => theme.spacing(3),
  width: 104,
};

const ConfirmSubscriptionCardNavigationButtons = props => {
  const { disabled, onEnroll, onGoBack } = props;

  return (
    <Box sx={styles.buttonBoxContainerStyles}>
      <Button onClick={() => onGoBack()} sx={footerButtonStyles} variant="outlined">
        Back
      </Button>
      <Button disabled={disabled} onClick={onEnroll} sx={footerButtonStyles}>
        Enroll
      </Button>
    </Box>
  );
};

ConfirmSubscriptionCardNavigationButtons.propTypes = {
  disabled: bool.isRequired,
  onEnroll: func.isRequired,
  onGoBack: func.isRequired,
};

export default ConfirmSubscriptionCardNavigationButtons;
